<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@modalLoungeDetails" id="modal-header">Lounge Details</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body" role="region" tabindex="0" aria-labelledby="modal-header">
    <app-lounge-details [lounge]="item"></app-lounge-details>
  </div>
</div>
